import { Component, OnInit, Input} from '@angular/core';
import { ItemMilestoneService } from '../../../api/item-milestone.service'
import { ItemPaginateMilestones,ItemMilestones } from '../../../class/itemclass'
import { DropDownClass } from '../../../class/dropdownclass'
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { HelperService,ErrorClass } from '../../../api/helper.service'
import { FileModal } from '../item/file-modal.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-item-milestone',
  templateUrl: './item-milestone.component.html',
  styleUrls: ['./item-milestone.component.scss']
})
export class ItemMilestoneComponent implements OnInit {

  public Editor = ClassicEditor;

  maxItemsPerPage = 10
  page = 1

  item_list:ItemPaginateMilestones = new ItemPaginateMilestones
  @Input() item:ItemMilestones = new ItemMilestones

  loading:boolean = false
  saving_item:boolean = false
  show_form:boolean = false

  item_dropdown:DropDownClass[] = []
 
  is_active:any = [
    {id:1,label:'Active'},
    {id:0,label:'InActive'},
  ]

  is_yesno:any = [
    {id:1,label:'Yes'},
    {id:0,label:'No'},
  ]
  
  constructor(
     private itemAPI:ItemMilestoneService,
     private help:HelperService,
     private modal:NgbModal,
  ) { }

  ngOnInit() {
     this.setDefaultValue()
     this.loadDropdowns().then(
       () => {
        this.loadRecords(this.maxItemsPerPage,1)
       }
     )
  }

  setDefaultValue(){
    this.item.item_name = ''
    this.item.milestone_date = ''
    this.item.description = '<p>&nbsp;</p><p>&nbsp;</p>'
    this.item.is_active = 1

  }

  async loadDropdowns(){
     this.itemAPI.getMilestoneItems().subscribe(async (data: any) => {
      this.item_dropdown = data
    }, (err: any) => {
      alert('Error Dropdowns' + JSON.stringify(err));
    })
  }

  countData:number = 1;
  loadRecords(maxItemsPerPage=10,page=1){
    this.loading = true
      this.itemAPI.getMilestones(maxItemsPerPage,page).subscribe(
        (data:ItemPaginateMilestones) => {
           this.item_list = data
           this.loading = false
           this.countData = this.item_list.data.length
        },
        (err) => {
          alert('Error:' + JSON.stringify(err))
          this.loading = false
        }
      )
  }

  generateNotif(notif,milestone_id){
     if(notif == 0){
      this.loading = true
        this.itemAPI.generateNotif(milestone_id).subscribe(
          (data) => {
            this.loading = false
            this.item.sent_notif = 1
            this.help.msgbox('Success','Successfully generated email schedules for notification')
          },(err) => {
            this.loading = false
            this.help.msgboxError("Error",JSON.stringify(err))     
          }
        )
     }else{
       this.help.msgboxError("Error",'Notification already generated')
     }
  }

  //Create Records
  saveItem(){
    this.saving_item = true
     this.itemAPI.saveMilestones(this.item).subscribe(
       (data:any) => {
         const ld = () => this.loadRecords()
         this.help.msgbox("Milestone Saving","Successfully Record Saved").then(ld)
         this.saving_item = false
         this.show_form = false
         this.setDefaultValue()
       },
       (err:ErrorClass) => {
         this.help.msgboxError("Milestone Error",err.error_message)
         this.saving_item = false
       }
     )
  }

  editItem(r){
     this.item = r
     this.show_form = true
     window.scrollTo(0,0);
  }

  showForm(){
     this.show_form = true
     this.setDefaultValue()
  }
  cancel(){
    this.show_form = false
    this.setDefaultValue()
  }

   showFileModal(img:any){
    const modRef = this.modal.open(FileModal,{size:'lg'});
  
     modRef.result.then(
       (data) => {
        if(data){

          const img_names = ['img1','img2','img3','img4','img5','img6','img7','img8','img9','img10'];
          img_names.map(
            (val) => {
              if(val==img){
                this.item[val] = data
             }
             return val
            }
          )
          


        }
      }
    )

  }

  //File Manager



}
